import { TreeNode } from 'primeng/api';
import { ReportDefinition } from './report-definition';
import { DimensionAttribute } from './dimension-attribute';
import { Dimension } from './dimension';
import { Result } from '../component/bi-analysis-result-view/bi-analysis-table/flat-table/model/result';
import { Filter } from './filter';
import { Sachgebiet } from './sachgebiet';

export class StoredReport {
    id: number | null = null;
    name: string | null = null;
    showTotalColumn: number = 0; // kein boolean wegen des datajdbcConverters
    description: string = '';
    isReadOnly: boolean = false;
    reportDefinition: ReportDefinition = new ReportDefinition( undefined, [] as string[], [] as string[], [] as string[], [], false, [] );
    exportedResult?: Result;
    hierarchy?: TreeNode<Dimension | DimensionAttribute>[];

    sachgebietOfLeadingFactTable?: Sachgebiet;
    autocompleteLabel: string = '';
}

export interface ReportOptionGroup {
    label: string;
    icon: string;
    items: StoredReport[];
}

export class StoredReportRequest {
    id: number | null = null;
    additionalFilters?: Filter[];
}
